var map = {
	"./de.json": [
		2409,
		409
	],
	"./en.json": [
		7756,
		756
	],
	"./fr.json": [
		4340,
		340
	],
	"./it.json": [
		3820,
		820
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6778;
module.exports = webpackAsyncContext;